import store from '@/store/store.js'

import { NEW_PACKGO_BETA_FEATURE } from '@/app/packgo/shared/constants'

import PackGoAnalytics from '@/app/users/analytics/packgo.analytics.js'
import PrinterService from '@/services/printer.service'
import { getVariable, setVariable, LOCAL_STORAGE_KEYS } from '@/utils/storage.js'

/** @return {boolean} */
export const isPackGoFeatureEnabled = () => {
  return store.getters.user.features.pack_and_go
}

/** @return {boolean} */
export const isNewPackGoBetaFeatureEnabled = () => {
  return store.getters.user.enabled_beta_features?.includes(NEW_PACKGO_BETA_FEATURE)
}

/** @return {boolean} */
export const isSwitchedToNewPackGo = () => {
  const userId = store.getters.user.id
  return getVariable(userId, LOCAL_STORAGE_KEYS.NEW_PACKGO_BETA_ACTIVE, true)
}

/**
 * Checks if the request to the print client server succeeds
 * @returns {Promise<boolean>}
 */
export const isPrintClientAvailable = async () => {
  const printers = await PrinterService.getAll()
  return Array.isArray(printers)
}

/**
 * Checks if the user has printers installed on his operating system
 * This will not check if the printer is a physical or virtual
 * This will also not check if the printer is turned on or not
 * @returns {Promise<boolean>}
 */
export const arePrintersAvailable = async () => {
  const printers = (await PrinterService.getAll()) ?? []
  return printers.length !== 0
}

/**
 * Printers can only be available if:
 *  - the Print Client is running (which requires a valid operating system)
 *  - the user uses a valid browser
 * @returns {Promise<boolean>}
 */
export const arePrintClientAndPrintersAvailable = async () => {
  return (await isPrintClientAvailable()) && (await arePrintersAvailable())
}

/**
 * @param {boolean} isOptedInForNewPackGo
 */
export function setLocaleStorageForPackGoOptingAndTrackAnalytics(isOptedInForNewPackGo) {
  setVariable(store.getters.user.id, LOCAL_STORAGE_KEYS.NEW_PACKGO_BETA_ACTIVE, isOptedInForNewPackGo)
  PackGoAnalytics.optInForNewPackGo(isOptedInForNewPackGo)
}
